import { Component } from '@angular/core';
import { FilterService } from '../services/filter.service';
import { FilterSelectorDialogComponent } from '../filter-selector-dialog/filter-selector-dialog.component';

@Component({
  selector: 'app-active-filter',
  imports: [FilterSelectorDialogComponent],
  templateUrl: './active-filter.component.html',
  styleUrl: './active-filter.component.scss'
})
export class ActiveFilterComponent {
  showFilterSelectorDialog = false;

  constructor(public filterService: FilterService) { }

  changeFilter($event: any) {
    $event.preventDefault();
    this.showFilterSelectorDialog = true;
  }
}
